import { print } from 'graphql';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { gql } from '../../graphql/Client';
import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface HazardSeverity extends BaseEntity {
  readonly description: string;
}
export type HazardSeveritiesCollection = RxCollection<HazardSeverity> | null;
export type HazardSeverityDocument = RxDocument<HazardSeverity>;

export const hazardSeveritySchema: RxJsonSchema<HazardSeverity> = {
  type: 'object',
  version: 0,
  description: 'describes a HazardSeverity object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
  },
};

export const hazardSeverityPullQueryBuilder = (doc: HazardSeverityDocument) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }
  const query = print(gql`
    query hazardSeverityFeed($siteId: ID!, $updatedAt: Float!, $limit: Int!) {
      hazardSeverityFeed(lastUpdateAt: $updatedAt, limit: $limit, siteId: $siteId) {
        description
        id
        isDeleted
        updatedAt
        version
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: rootStore.user.siteId,
      updatedAt: doc.updatedAt,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export default {};
